import {Button} from "@pg-design/button-module";

import {ApplicationModalButton} from "../../application/components/ApplicationModalButton";
import {ApplicationModalStep} from "../../application/types/ApplicationModalStep";
import {LeadTopicType} from "../../application/types/lead/LeadTopicType";
import {ApplicationSource, ApplicationSourceSection} from "../../application/utils/form/application_form_source";

interface IProps {
    vendorId: number;
    offerId: number;
    propertyId: number;
    vendorName: string;
    offerName: string;
}

export const PropertyDetailDetailsParkingInquiryButton = (props: IProps) => {
    const {vendorId, offerId, propertyId, vendorName, offerName} = props;

    return (
        <ApplicationModalButton
            vendorId={vendorId}
            offerId={offerId}
            propertyId={propertyId}
            source={ApplicationSource.Property}
            sourceSection={ApplicationSourceSection.TABLE}
            initialStep={ApplicationModalStep.APPLICATION_FORM_WITH_TOPIC}
            topic={{
                type: LeadTopicType.PARKING
            }}
            render={({openModal}) => (
                <Button
                    variant="highlight_primary"
                    size="small"
                    onClick={() =>
                        openModal({
                            clickText: "Zapytaj o dostępność miejsc postojowych",
                            source: "property_detail_table_parking",
                            vendorName,
                            offerName
                        })
                    }
                >
                    Zapytaj o dostępność miejsc postojowych
                </Button>
            )}
        />
    );
};
import {Button} from "@pg-design/button-module";

import {ApplicationModalButton} from "../../application/components/ApplicationModalButton";
import {ApplicationModalStep} from "../../application/types/ApplicationModalStep";
import {LeadTopicType} from "../../application/types/lead/LeadTopicType";
import {ApplicationSource, ApplicationSourceSection} from "../../application/utils/form/application_form_source";

interface IProps {
    vendorId: number;
    offerId: number;
    propertyId: number;
    vendorName: string;
    offerName: string;
}

export const PropertyDetailDetailsParkingInquiryButton = (props: IProps) => {
    const {vendorId, offerId, propertyId, vendorName, offerName} = props;

    return (
        <ApplicationModalButton
            vendorId={vendorId}
            offerId={offerId}
            propertyId={propertyId}
            source={ApplicationSource.Property}
            sourceSection={ApplicationSourceSection.TABLE}
            initialStep={ApplicationModalStep.APPLICATION_FORM_WITH_TOPIC}
            topic={{
                type: LeadTopicType.PARKING
            }}
            render={({openModal}) => (
                <Button
                    variant="highlight_primary"
                    size="small"
                    onClick={() =>
                        openModal({
                            clickText: "Zapytaj o dostępność miejsc postojowych",
                            source: "property_detail_table_parking",
                            vendorName,
                            offerName
                        })
                    }
                >
                    Zapytaj o dostępność miejsc postojowych
                </Button>
            )}
        />
    );
};
